import React, { memo, useContext, useState } from "react";

import clsx from "clsx";
import { makeStyles } from "@mui/styles";

import { AddCircle, ListRounded, Refresh } from "@mui/icons-material";

import { withRouter } from "react-router-dom";
import {
  Box,
  Button,
  TablePagination,
  TextField,
  lighten,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import ExportDialog from "./ExportDialog";
import "../../../../components/Extra/GlobalCssSlider.css";
import { serverphpvet } from "../../../../config/const";
import AuthContext from "../../../../Context/Auth/AuthContext";
import clienteAxios from "../../../../config/axios";
import { saveAs } from "file-saver";
const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
  ocultar: {
    display: "none",
  },
  "MuiTablePagination-toolbar": {
    padding: "none",
  },
}));
const ToolBarTable = (props) => {
  const { usuario } = useContext(AuthContext);
  const classes = useToolbarStyles();
  const {
    titulo,
    arrayExport,
    columns,
    expandible,
    campoExport,
    soloTitulo,
    botonAdd,
    funcionAdd,
    tabla,
    funcionReload,
    pagination,
    rowsPerPage,
    rows,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    deshabilitarbotonAdd,
    //PROPIEDAD DE SOLO TITULO
    etiqueta,
    inputData,
    setinputData,
    funcionInputKey,
    inputRef,
    socket,
    eliminadoEstado,
  } = props;

  const [tipo, settipo] = useState("seleccion");
  const [open, setopen] = useState(false);

  const funcPdf = async () => {
    // "search_avanzado": {
    //     "perFecReg1": "",
    //     "perFecReg2": ""
    // }

    // const json = {
    //   tipo,
    //   search,
    //   lista: arrayExport.map((itemExport) => itemExport[campoExport]),
    //   rucempresa: usuario.rucempresa,
    //   rol: usuario.rol,
    //   search_avanzado: fullBuscador,
    // };

    window.open(
      `${serverphpvet}reportes/historiaclinica_seleccionado.php?id=${arrayExport}&empresa=${usuario.rucempresa}`
    );
  };
  const funcExcel = async (todo) => {
    try {
      const json = {
        tipo: todo ? "todos" : "seleccion",
        lista: arrayExport,
        rucempresa: usuario.rucempresa,
        rol: usuario.rol,
      };

      const res = await clienteAxios.post(
        `/reportes/excel/historia_clinica`,
        {
          ...json,
        },
        { responseType: "blob" }
      );
      const excelBlob = new Blob([res.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(excelBlob, `${titulo}.xlsx`);
      setopen(false);
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <>
      {soloTitulo ? (
        <Box
          display="flex"
          justifyContent="space-between"
          className={clsx(classes.root, {
            [classes.highlight]: false,
          })}
          alignItems="center"
        >
          {etiqueta ? (
            <TextField
              id="inputData"
              label={etiqueta}
              inputRef={inputRef}
              onKeyPress={async (e) => {
                await funcionInputKey(e);
              }}
              value={inputData}
              name="inputData"
              size="small"
              onChange={(e) => {
                setinputData(e.target.value);
              }}
            />
          ) : null}
          <Button
            style={{ padding: ".0rem" }}
            variant="text"
            color="inherit"
            onClick={async () => {
              if (funcionReload) {
                funcionReload();
              }
            }}
          >
            {titulo}
          </Button>
          {botonAdd ? (
            <IconButton
              aria-label=""
              disabled={deshabilitarbotonAdd}
              color="secondary"
              style={{ padding: ".5rem" }}
              onClick={() => funcionAdd()}
              size="small"
            >
              <AddCircle fontSize="medium" />
            </IconButton>
          ) : null}
        </Box>
      ) : (
        <>
          <ExportDialog
            funcExcel={funcExcel}
            eliminadoEstado={eliminadoEstado}
            tipo={tipo}
            settipo={settipo}
            open={open}
            setopen={setopen}
            funcPdf={funcPdf}
            arrayExport={arrayExport}
            columns={columns}
            titulo={titulo}
            expandible={expandible}
            campoExport={campoExport}
            tabla={tabla}
            socket={socket}
          />
          <Box
            display="flex"
            justifyContent="space-between"
            className={clsx(classes.root, {
              [classes.highlight]: false,
            })}
          >
            <Button
              style={{ padding: ".0rem" }}
              variant="text"
              color="inherit"
              onClick={async () => {
                if (funcionReload) {
                  funcionReload();
                }
              }}
              startIcon={<Refresh />}
            >
              ACTUALIZAR
            </Button>
            <Box display="flex" justifyContent="space-around">
              <TablePagination
                labelRowsPerPage="Filas"
                rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                component="div"
                count={pagination.numRows}
                rowsPerPage={rowsPerPage}
                className={"MuiTablePagination-toolbar"}
                backIconButtonProps={{
                  style: { margin: 0, padding: 0 },
                  size: "small",
                  maxHeight: "25px",
                }}
                nextIconButtonProps={{
                  disabled: pagination.numRows < rows.length,
                  style: { margin: 0, padding: 0 },
                  size: "small",
                  maxHeight: "25px",
                }}
                SelectProps={{
                  style: { margin: 0, padding: 0 },
                  size: "small",
                  inputProps: { style: { margin: 0, padding: 0 } },
                  maxHeight: "25px",
                }}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
              {arrayExport ? (
                <Tooltip title="Exportar">
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    disabled={arrayExport.length === 0}
                    onClick={() => setopen(true)}
                    style={{ margin: 0, padding: 0 }}
                  >
                    <ListRounded />
                  </IconButton>
                </Tooltip>
              ) : null}
            </Box>
          </Box>
          <Divider />
        </>
      )}
    </>
  );
};
export default memo(withRouter(ToolBarTable));
